import React, { Component } from 'react';
import { connect } from 'react-redux';
import ProjectView from '../components/views/Projects';
import {
  addProject, closeModal, datesChanged, editProject, openModal,
  projectSearch, removeProject, updateModal,
} from '../redux/actions';
import { getCategories } from '../redux/actions/categories';
import type {
  Project,
  ProjectCategory,
  ProjectRequest,
  Projects as ProjectsType,
  SingleModalState,
  State,
  User,
} from '../types';

export type ProjectProps = {
  currentUser: User,
  projects: ProjectsType,
  onAddProject: Function,
  onRemoveProject: Function,
  onEditProject: Function,
  onProjectSearch: Function,
  onDatesChanged: Function,
  onOpenModal: Function,
  onCloseModal: Function,
  onUpdateModal: Function,
  fetchCategories: Function,
  navigate: object,
  location: object,
  requests: object,
  categories: ProjectCategory[],
};

class Projects extends Component<ProjectProps> {
  render(): React.ReactNode {
    return (
      <ProjectView
        {...this.props}
      />
    );
  }
}

const mapStateToProps = (state: State) => ({
  ...state,
  requests: state.requests.projects,
});

const mapDispatchToProps = dispatch => ({
  onAddProject: (project: ProjectRequest) => dispatch(addProject(project)),
  onEditProject: (project: Project) => dispatch(editProject(project)),
  onRemoveProject: (projectId: number) => dispatch(removeProject(projectId)),
  onProjectSearch: (year: number, month: number) => dispatch(projectSearch(year, month)),
  onDatesChanged: (year: number, month: number) => dispatch(datesChanged(year, month)),
  onOpenModal: (modal: SingleModalState) => dispatch(openModal(modal)),
  onCloseModal: (modal: SingleModalState) => dispatch(closeModal(modal)),
  onUpdateModal: (modal: SingleModalState) => dispatch(updateModal(modal)),
  fetchCategories: () => dispatch(getCategories()),
});

const ConnectedProjects = connect(mapStateToProps, mapDispatchToProps)(Projects as any);

export default ConnectedProjects;
